/** Import the ACR headers from the `acr-injection` package dynamically as it uses some timer which will cause e2e or unit tests to timeout */
const importAcrHeaders = () => import('@smg-real-estate/acr-injection/umd').then((m) => m.default);

export async function getAcrHeaders(): Promise<Record<string, string>> {
  try {
    const acrInjection = await importAcrHeaders();
    return await acrInjection.getAcrHeaders();
  } catch (error) {
    console.error('Failed to get ACR headers:', error);
    return {};
  }
}

export function shouldInjectAcrHeaders(): boolean {
  return typeof window !== 'undefined' && import.meta.env.VUE_APP_STAGE === 'prod';
}
